import { render, staticRenderFns } from "./group-video-modal.vue?vue&type=template&id=a94c438a"
import script from "./group-video-modal.vue?vue&type=script&lang=js"
export * from "./group-video-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports